<template>

    <div class="container textAlignCenter">
        <StepGuide :stepCount="3"></StepGuide>

        <div class="padding body textAlignCenter">

        <h1 class="teal padding textAlignCenter">Success!</h1>

        <h3 class="padding">Thank you for your order</h3>

            <div>
                <h4 class="padding">Your order number is <span class="teal">{{printJob.id}}</span></h4>

        <p>Delivery can be expected in 2-3 working days</p>
        <p>If you have any queries, please contact</p>
                <div class="padding paddingTopSmall">
                    <p>Ravensworth Client Services:</p>
                    <p class="teal">0191 917 9331</p>
                    <p class="teal">client.support@ravensworth.co.uk</p>
                </div>
            </div>
            <div class="padding">
                <p>Your order is complete, please close this window</p>
                <!--<el-button v-on:click="close('quit')" class="redButton ravensworthButtons">Close</el-button> &lt;!&ndash; this has to close the window &ndash;&gt;-->
            </div>

        <!--<el-button v-on:click="self.close()">Close</el-button> &lt;!&ndash; this has to close the window &ndash;&gt;-->

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue';
    import PrintJobSelections from '@/components/PrintJobSelections.vue';

    export default {
        name: "confirmation",
        components: {
            StepGuide,
            PrintJobSelections
        },
        props: {
            searchParams: {},
            printJob: {}
        },
        data() {
            return {
                uploadPercentage: '',
            }
        },
        created() {

            window.sessionStorage.removeItem('_token')
            window.sessionStorage.removeItem('_branchCode')
            window.sessionStorage.removeItem('_filename')
            window.sessionStorage.removeItem('_propertyName')
            window.sessionStorage.removeItem('_reference')
            window.sessionStorage.removeItem('_source')
            window.sessionStorage.removeItem('_printJob')

        },
        methods: {
            next() {
                // Router.push({
                //     name: 'wizardProducts'
                // });
            },
            close(cmd) {
                if (cmd == 'quit') {
                    open(location, '_self').close();
                }
                return false;
            }
        }
    };
</script>